import { styled } from 'stitches.config'
import * as Tabs from '@radix-ui/react-tabs'
import { Text } from 'components/Text'

export const TabsRoot = styled(Tabs.Root, {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
})

export const StyledList = styled(Tabs.List, {
  flexShrink: 0,
  display: 'flex',
  gap: '$1',
})

export const StyledTrigger = styled(Tabs.Trigger, {
  display: 'flex',
  gap: '$1',
  flexShrink: 0,
  padding: '12px $2',
  cursor: 'pointer',
  color: '$tertiary-400',
  userSelect: 'none',
  backgroundColor: '$accent-white',
  borderRadius: '$3 $3 0 0',
  bottom: '-1px',

  '&:hover': {
    color: '$tertiary-1000',
  },

  '&:focus-visible': {
    outline: 'none',
    color: 'rgb(0, 95, 204) !important',
  },

  '&[data-state="active"]': {
    color: '$tertiary-1000',
    fontWeight: '$bold',
    position: 'relative',
    backgroundColor: '$accent-white',
    border: '1px solid $tertiary-300',
    borderBottom: 'none',

    [`& ${Text}`]: {
      '@bp2': {
        display: 'block',
      },
    },

    '&::after': {
      content: ' ',
      bottom: '-1px',
      left: 0,
      position: 'absolute',
      height: '1px',
      backgroundColor: '$accent-white',
      width: '100%',
    },
  },

  [`& ${Text}`]: {
    display: 'none',

    '@bp3': {
      display: 'block',
    },
  },
})

export const StyledContent = styled(Tabs.Content, {
  flexGrow: 1,
  backgroundColor: '$accent-white',
  padding: '$2',
  border: '1px solid $tertiary-300',
  borderRadius: '0px $4 $4 $4',

  '&:focus-visible': {
    outline: 'none',
    color: 'rgb(0, 95, 204) !important',
  },

  '@bp1': {
    padding: '$2 $4 $4',
  },
})
